import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {getMyApplicationsListUrl, IMyApplicationsListItem, IMyApplicationsListResponse} from "./fetch_my_applications_list";

export const transformMyApplicationsListError = (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [response.status]);

export const getMyApplicationsListApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyApplicationsList: builder.query<IMyApplicationsListItem[], void>({
            query: () => ({
                url: getMyApplicationsListUrl()
            }),
            transformResponse: (response: IMyApplicationsListResponse) => response.results ?? [],
            transformErrorResponse: transformMyApplicationsListError
        })
    })
});

export const {useGetMyApplicationsListQuery} = getMyApplicationsListApi;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {getMyApplicationsListUrl, IMyApplicationsListItem, IMyApplicationsListResponse} from "./fetch_my_applications_list";

export const transformMyApplicationsListError = (response: FetchBaseQueryError) => getIgnoredNotifyResponse(response, [response.status]);

export const getMyApplicationsListApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getMyApplicationsList: builder.query<IMyApplicationsListItem[], void>({
            query: () => ({
                url: getMyApplicationsListUrl()
            }),
            transformResponse: (response: IMyApplicationsListResponse) => response.results ?? [],
            transformErrorResponse: transformMyApplicationsListError
        })
    })
});

export const {useGetMyApplicationsListQuery} = getMyApplicationsListApi;
